<section class="pt-0 pb-0">
    <ngx-spinner></ngx-spinner>

<div id="demo" class="carousel slide hero-slider casestudy-banner mt-110" data-ride="carousel">
    <div class="container">
        <div class="bg-slider min-h-400">
        <div class="carousel carousel-inner  art mb-0 ">
            <ngx-slick class="carousel" #slickModal="slick-modal" [config]="slideConfig">
                <div ngxSlickItem *ngFor="let data of sliderData" class="slide" (click)="itemClickOnNgxClick(data)">
                    <img [src]="imageBasePath + data.image" alt="first slide" style="display: block; width: 100%;">
                    <div class="carousel-caption d-none d-md-block text-left">
                        <h3 [innerHTML]="transform(data?.title)" id="scrollingToTop"></h3>
                        <!-- <p><strong><span class="roboto-light">By<strong>:</strong></span> {{data?.author}}</strong></p> -->
                    </div>
                </div>
            </ngx-slick>
        </div>
    </div>
    </div>
</div>

<section class="casestudy-no-bg casestudy-page pt-0 pb-280">
    <div class="container">
        <div class="inner-container">
            <h2 class="page-title">Case Studies</h2>
            <div class="row study-row">

                <div class="col-md-4 study-col" *ngFor="let data of caseStudy; let i=index; let isOdd=odd">
                    <div class="wrap h-100 hide-on-init" animateOnScroll animationName="animated fadeIn">
                        <div class="study-img"><img [src]="imageBasePath + data.images[0]" alt=""></div>
                        <h3 [innerHTML]="transform(data.title)"></h3>
                        <div class="study-content">
                            <p class="text-left">
                                <span [innerHTML]="transform((data.description.length > 100) ? (data.description | slice:0:100 | safeHtml) + '...' : data.description)">
                                </span>
                            </p>
                            <a [routerLink]="['/knowledge-section/case-study/detail',data?._id]"
                                class="btn btn-primary rounded-pill pr-4 pl-4">View Case Study</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pagination-row mt-5 mb-0" [hidden]="!showPagination">
                <div class="col-md-12 text-right">
                    <div class="pagination justify-content-end">
                        <div class="page-item">
                            <pagination [boundaryLinks]="true" [itemsPerPage]="itemsPerPage" [totalItems]="totalItems" [(ngModel)]="page"
                                (pageChanged)="pageChanged($event)"
                                [customPreviousTemplate]="prevTemplate"
                                [maxSize]="maxSize"
            [customNextTemplate]="nextTemplate"
            [customFirstTemplate]="firstTemplate"
            [customLastTemplate]="lastTemplate"
            ></pagination>
            <ng-template #nextTemplate let-disabled="disabled" let-currentPage="currentPage">
                <ng-container *ngIf="!disabled">
                  Next
                </ng-container>
              </ng-template>

              <ng-template #prevTemplate let-disabled="disabled" let-currentPage="currentPage">
                <ng-container *ngIf="!disabled">
                  Previous
                </ng-container>
              </ng-template>

              <ng-template #lastTemplate let-disabled="disabled" let-currentPage="currentPage">
                <ng-container *ngIf="!disabled">
                Last
                </ng-container>
              </ng-template>
               
              <ng-template #firstTemplate let-disabled="disabled" let-currentPage="currentPage">
                <ng-container *ngIf="!disabled">
                First
                </ng-container>
              </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</section>
